import React, {useEffect, useRef, useState, useStateWithLabel} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import BaseButton from "../../base-components/base-button";
import StepsLoader from "../steps-loader";
import InputFieldCountry from '../../base-components/base-input-country';

import StepFooterAction from "../../base-components/step-footer-action";
import countriesData from 'assets/data/country-data.json'

const NationalityStep = ({ _step_service, error, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const form = useRef()
    const name = "nationality"
    const data = getDataFromContext(step_ID)
    const initialInputData = data && data[name] && data[name] !== "" ? data[name] : ""
    const initialSelectedNationalityArray = {}
    let default_step_form = []
    const lang = localStorage.getItem("language")

    const InitSelectedNat = ()=> {
        if (data?.nationality && data?.nationality !== "") {
            if (data.internal_nationality_country) {
                Object.keys(data.internal_nationality_country).forEach(name => {
                    const value = data.internal_nationality_country[name]
                    initialSelectedNationalityArray[name] = {callingCode: value.callingCode , code: value.code, name: value.name}
               })
            }
        }
    }
    InitSelectedNat()
  
    const [inputData, setInputData] = useStateWithLabel(initialInputData, 'inputData')
    const [nextTick, setNextTick] = useStateWithLabel(false, "nextTick")
    const [fullNationalitySlection, setFullNationalitySlection] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedNationalityArray, setSelectedNationalityArray] = useState(initialSelectedNationalityArray)
    const [exclude, setExclude] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [countriesFULL] = useState(countriesData.map(ctr => ({
        name: ctr.translations[lang.toLocaleLowerCase()],
        callingCode: ctr.callingCodes[0],
        code: ctr.altSpellings[0],
        translation: {
            de: ctr.translations.de,
            fr: ctr.translations.fr,
            nl: ctr.translations.nl
        }
    })))
    const BE = countriesFULL.find(ct => {
        return ct.code === "BE"
    })
    const defaultCounty=  {
        country: BE.name,
        code: BE.code,
        callingCode: BE.callingCode
    }

    const initDefaultStepForm = () => {
        if (data ) {
            if (data?.internal_nationality_country && Object.keys(data?.internal_nationality_country).length > 0) {
                for (const [key, value] of Object.entries(data?.internal_nationality_country)) {
                default_step_form.push({
                    type: "country",
                    id: key,
                    defaultCounty: {
                        country: value.name,
                        code: value.code,
                        callingCode: value.callingCode
                    }
                })
            }
            } else {
            default_step_form = [ {
                type: "country",
                id: "birth_country",
                defaultCounty,
                useDefault: true
            }]
        } 
        } 
    }
    initDefaultStepForm()

    const [nationalityArr, setNationalityArr] = useState(default_step_form)

    useEffect(() => {
        setInputData(Object.values(selectedNationalityArray).map(nt => (nt.code)).join(";"))
        nationalityArr.length > 2 && setFullNationalitySlection(true)
        const __exclude = Object.values(selectedNationalityArray).map(code => code.code)
        setExclude(__exclude)
    }, [selectedNationalityArray])

    useEffect(() => {
        // if (inputData !== "" && initialInputData !== "") {
        //     setInputData( initialInputData )   
        // }
        setIsValid(nationalityArr.length !== inputData.split(';').length)
    }, [inputData])

    useEffect(() => {
        if (nextTick) {
        _step_service({ step_ID, setIsLoading, next_step })
      }
    }, [nextTick])

    useEffect(() => {
        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:nationality",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             });
        }
     }, [])
    
    const getInputValue = (name, value) => {
        if (value) {
            setSelectedNationalityArray({ ...selectedNationalityArray, [name]: {callingCode: value.callingCode , code: value.code, name: value.country}})
        }
    }

    const addNationnality = () => {
        const length = nationalityArr.length + 1
        nationalityArr.push({
            type: "country",
            id: "birth_country-" + length,
            useDefault: false
        })
        nationalityArr.length > 2 && setFullNationalitySlection(true)
        setIsValid(nationalityArr.length !== inputData.split(';').length)
        setNationalityArr([...nationalityArr])
    }

    const removeNationality = (item) => {
        const id = item.id
        const code = selectedNationalityArray[id]?.code
        
        setInputData(inputData => inputData.split(";").filter(ar => ar !== code).join(";"))
        const excl = exclude.filter(ar => ar !== code)
        setExclude(excl)
        
        delete selectedNationalityArray[id]
        setSelectedNationalityArray(selectedNationalityArray)

        const newArr = nationalityArr.filter(itm => itm.id !== id)
        setNationalityArr([...newArr])
        newArr.length < 3 && setFullNationalitySlection(false)
        setIsValid(newArr.length !== inputData.split(';').length)
    }

    const action = () => {
        if (inputData !== "") {
            setDataToContext(step_ID, step_URL, "nationality", inputData)
            setDataToContext(step_ID, step_URL, "internal_nationality_country", JSON.stringify(selectedNationalityArray))
        }
        setNextTick(true)
    }

    return (
        <>
            <StepsLoader loading={isLoading}>
                 <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('personal_infos.Personal_info_nationality.title')}</h3>
                        <p>{t('personal_infos.Personal_info_nationality.text')}</p>
                        {nationalityArr.map(input => (
                            <div
                                className="nationnality-country-wrapper"
                                key={input.id}
                            >
                                {
                                    nationalityArr.length > 1 && <div
                                    className="nationnality-country-wrapper__delette"
                                    onClick={() => removeNationality(input)}>×</div>
                                }
                                
                                 <InputFieldCountry
                                    label={t('personal_infos.Personal_info_nationality.label')}
                                    name={input.id}
                                    getInputValue={getInputValue}
                                    error={error}
                                    type={input.type}
                                    exclude={exclude}
                                    value={input.defaultCounty}
                                    useDefault={input.useDefault}
                                    />
                            </div>
                       ))}
                    </BaseParagraph>
                </form>
                {!fullNationalitySlection && !isValid && <BaseButton blue nokb caption={t('personal_infos.Personal_info_nationality.add_country')} action={addNationnality} />}
                
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={isValid} />
            </StepsLoader>
        </>
    )
}

NationalityStep.propTypes = {
    name: PropTypes.string
}

NationalityStep.defaultProps = {
    name: "email-step"
}


export default NationalityStep